import { Phone, Mail, LifeBuoy, ArrowUpRight } from "lucide-react";
import { BRAND } from "../../lib/api";
import { Stagger, Item, AnimatedCard } from "../../components/motion";
import { WhatsAppButton } from "../../components/common";

export default function Support() {
  return (
    <Stagger gap={0.1}>
      <Item className="surface gradient-border relative overflow-hidden p-8 sm:p-12">
        <div className="orb -right-24 -top-24 h-72 w-72" style={{ background: "rgba(34,197,94,0.18)" }} />
        <div className="orb -bottom-24 left-10 h-60 w-60" style={{ background: "rgba(227,10,23,0.1)" }} />
        <div className="relative max-w-xl">
          <div className="mb-5 grid h-12 w-12 place-items-center rounded-2xl bg-[var(--brand-50)] text-[var(--brand)]"><LifeBuoy className="h-6 w-6" /></div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="page-title">Yardıma mı ihtiyacınız var?</h1>
          <p className="mt-3 text-slate-500">Eğitim danışmanlarımız eğitimleriniz, sınavlarınız ve sertifikalarınızla ilgili sorularınızda size yardımcı olmaya hazır.</p>
          <WhatsAppButton className="mt-7 w-full sm:w-auto h-12" testid="support-whatsapp-btn" />
        </div>
      </Item>
      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        {[
          [Phone, "Telefon", BRAND.phone, BRAND.phoneHref, "support-phone-link"],
          [Mail, "E-posta", BRAND.email, `mailto:${BRAND.email}`, "support-email-link"],
        ].map(([Icon, label, val, href, tid]) => (
          <AnimatedCard key={label} className="group">
            <a href={href} className="flex items-center gap-4 p-6" data-testid={tid}>
              <div className="grid h-12 w-12 place-items-center rounded-xl bg-slate-100 text-[var(--ink)] transition-transform duration-300 group-hover:scale-110"><Icon className="h-5 w-5" /></div>
              <div className="flex-1"><p className="text-xs text-slate-400">{label}</p><p className="font-bold text-[var(--ink)]">{val}</p></div>
              <ArrowUpRight className="h-5 w-5 text-slate-300 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[var(--brand)]" />
            </a>
          </AnimatedCard>
        ))}
      </div>
    </Stagger>
  );
}
